// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lm0Gi","badges":"styles_badges__1hjii"};